import ambitionDefaultBuiltin from './builtin/ambition-default.html?raw';
import symplrBuiltin from './builtin/symplr.html?raw';
import compactBuiltin from './builtin/compact.html?raw';
import {
  SCORE_CARD_HTML_TEMPLATE_FILES,
  DEFAULT_SCORE_CARD_HTML_TEMPLATE,
  type ScoreCardHtmlTemplateId,
  normalizeScoreCardHtmlTemplate,
} from '../../../shared/scoreCardHtmlTemplates.js';

/**
 * Share-Score-Card-HTML: optional fetch aus /public, sonst Builtin (?raw).
 * Template-Auswahl: Konfigurator (scan_templates.score_card_html_template) oder ?template=…
 */
export { DEFAULT_SCORE_CARD_HTML_TEMPLATE, normalizeScoreCardHtmlTemplate };
export type { ScoreCardHtmlTemplateId };

const BUILTIN_SOURCES: Record<ScoreCardHtmlTemplateId, string> = {
  'ambition-default': ambitionDefaultBuiltin,
  symplr: symplrBuiltin,
  compact: compactBuiltin,
};

const SAFE_ID = /^[a-z0-9-]{1,64}$/i;

/** Erkennt SPA-index.html o.ä. statt echtem Template (Platzhalter fehlen). */
function looksLikeScoreCardTemplate(html: string): boolean {
  return (
    html.includes('{{SCANNED_URL}}') &&
    (html.includes('{{TOP_HEADER_HTML}}') ||
      html.includes('{{MAIN_BODY_HTML}}') ||
      html.includes('{{PAGE_TITLE}}'))
  );
}

/** Query-Parameter ?template= — ungültige Werte fallen auf Default zurück. */
export function resolveScoreCardTemplateId(param: string | null): ScoreCardHtmlTemplateId {
  if (!param || !SAFE_ID.test(param)) return DEFAULT_SCORE_CARD_HTML_TEMPLATE;
  const id = param.toLowerCase();
  if (id === 'minimal') return 'symplr';
  return id in SCORE_CARD_HTML_TEMPLATE_FILES ? (id as ScoreCardHtmlTemplateId) : DEFAULT_SCORE_CARD_HTML_TEMPLATE;
}

function publicTemplateUrl(templateId: ScoreCardHtmlTemplateId): string {
  const file = SCORE_CARD_HTML_TEMPLATE_FILES[templateId];
  const base = import.meta.env.BASE_URL ?? '/';
  const normalized = base.endsWith('/') ? base.slice(0, -1) : base;
  return `${normalized}/score-card-templates/${file}`;
}

export async function loadScoreCardTemplateSource(templateId: ScoreCardHtmlTemplateId): Promise<string> {
  const builtin = BUILTIN_SOURCES[templateId];
  if (!builtin) throw new Error(`Unknown score card template: ${templateId}`);

  try {
    const res = await fetch(publicTemplateUrl(templateId), { cache: 'no-store' });
    if (res.ok) {
      const text = await res.text();
      if (looksLikeScoreCardTemplate(text)) return text;
    }
  } catch {
    /* Builtin nutzen */
  }

  return builtin;
}
